export default "__VITE_ASSET__edb13a7e__"